import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-table-movement',
  templateUrl: './table-movement.component.html',
  styleUrls: ['./table-movement.component.scss'],
})
export class TableMovementComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
